import styled from 'styled-components';

export const ClassCoursesListContainer = styled.ul`
  list-style: none;

  & > :not(:last-child) {
    margin-bottom: 24px;
  }
`;
